import React, { useEffect, useReducer, useState } from "react";
import DashboardLayout from "../../../../layoutcontainers/DashboardLayout";
import {
  Autocomplete,
  Box,
  Card,
  CardHeader,
  Chip,
  IconButton,
  Stack,
  Tab,
  Tabs,
  TextField,
  Typography,
} from "@mui/material";
import MaterialTypography from "../../../../components/MaterialTypography";
import MaterialDataGrid from "../../../../components/MaterialDataGrid";
import PageLoading from "../../../../components/Loading/PageLoading";
import { useNavigate } from "react-router-dom";
import VisibilityIcon from "@mui/icons-material/Visibility";
import _ from "lodash";
import { useLoading } from "../../../../context/LodingContext";
import request from "graphql-request";
import BASEURL from "../../../../pages/Utils/Baseurl";
import { downloadExcelFile } from "../../../function/downloadExcel";
import {
  allUsers,
  allProducts,
  StockExpiryReport,
  ExportStockExpiryReport,
  allBrands,
  allProductCategories,
  GetCompetitorAnalysisReport,ExportCompetitorReport
} from "../ReportData";
import MaterialBox from "../../../../components/MaterialBox";
import Grid from "@mui/material/Grid2";
import {
  Tooltip,
  Legend,
  ResponsiveContainer,
  BarChart,
  CartesianGrid,
  XAxis,
  YAxis,
  Bar,
} from "recharts";
import OptionConvert from "../../../components/OptionConvert";
import {
  realtimeInventoryState,
  RealtimeInventoryStateMange,
} from "../ReportStateMange";
import RefreshIcon from "@mui/icons-material/Refresh";
import Swal from "sweetalert2";
import URL from "../../../../pages/Utils/url";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import ReusableFilter from "../../../components/ReusableFilter";
import FilterListIcon from "@mui/icons-material/FilterList";
import { getallmall } from "../../productDisplayCompliance/api/query";
import { getAllCompetitorProducts } from "../../competitorAnalysis/data";

function CompetitorAnalysisReport() {
  const navigate = useNavigate();
  const { setCirleLoading } = useLoading();
  const [SlowMovingItemsData, dispatch] = useReducer(
    RealtimeInventoryStateMange,
    realtimeInventoryState
  );
  const [isLoading, setIsLoading] = useState(false);
  const [datas, setData] = useState([]);
  const [value, setValue] = useState(0);
  const [agentOptions, setAgentOptions] = useState([
    { label: "All", value: "All" },
  ]);
  const [productCategoryOptions, setProductCategoryOptions] = useState([
    { label: "All", value: "All" },
  ]);
  const [productOptions, setProductOptions] = useState([
    { label: "All", value: "All" },
  ]);
  const [brandOptions, setBrandOptions] = useState([
    { label: "All", value: "All" },
  ]);

  const [dialogOpen, setDialogOpen] = useState(false);

  // Pagination state for graph view
  const [currentPage, setCurrentPage] = useState(0);
  const recordsPerPage = 5;

  useEffect(() => {
    const fetchAllData = async () => {
      try {
        await Promise.all([
          fetchAgentName(),
          // fetchProduct(),
          // fetchProductCategory(),
          // fetchBrand(),
          fetchCompetitorAnalysisData()
        ]);
      } catch (error) {
        console.error("Error fetching data", error);
      }
    };

    fetchAllData();
  }, []);

  // const processedData = datas?.flatMap((entry) =>
  //   entry.agreedProducts.map((product) => ({
  //     productName: product.product?.productName || "Unknown Product",
  //     quantity: product.quantity || 0,
  //   }))
  // );

  // Calculate pagination values
  const totalPages = Math.ceil(datas?.length / recordsPerPage);
  const currentData = datas?.slice(
    currentPage * recordsPerPage,
    (currentPage + 1) * recordsPerPage
  );


  // Pagination handlers
  const handleNext = () => {
    if (currentPage < totalPages - 1) {
      setCurrentPage(currentPage + 1);
    }
  };

  const handlePrevious = () => {
    if (currentPage > 0) {
      setCurrentPage(currentPage - 1);
    }
  };

  // Reset pagination when data changes
  const resetPagination = () => {
    setCurrentPage(0);
  };

  //reset filter data
  const resetFilters = () => {
    dispatch({ name: "reset" });
    setData([]);
  };

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };
  //table row and colomn
  const SlowMovingItemsListTable = {
    columns: [
      {
        headerName: "S.No",
        field: "sno",
        name: "S.NO",
        flex: 1,
        disableColumnMenu: true,
        editable: false,
      },
      {
        headerName: "Product Code",
        field: "productCode",
        name: "productCode",
        flex: 1,
        disableColumnMenu: true,
        editable: false,
      },
      {
        headerName: "Product Name",
        field: "productName",
        name: "productName",
        flex: 1,
        disableColumnMenu: true,
        editable: false,
      },
      {
        headerName: "Product Brand",
        field: "productBrand",
        name: "productBrand",
        flex: 1,
        disableColumnMenu: true,
        editable: false,
      },
      {
        headerName: "Product Category",
        field: "productCategory",
        name: "productCategory",
        flex: 1,
        disableColumnMenu: true,
        editable: false,
      },
      {
        headerName: "Competitor Price",
        field: "competitorPrice",
        name: "competitorPrice",
        flex: 1,
        disableColumnMenu: true,
        editable: false,
      },
      {
        headerName: "Agent Name",
        field: "agentName",
        name: "agentName",
        flex: 1,
        disableColumnMenu: true,
        editable: false,
      },
    ],
    rows: datas?.map((value, i) => ({
      id: i+1,
      sno: i + 1,
      productCode: value?.productCode,
      productName: value?.productName,
      productBrand: value?.productBrand,
      productCategory: value?.productCategory,
      competitorPrice: value?.competitorPrice,
      agentName: value?.agentName,
      createdAt: value?.createdAt,
      lastupdate: value?.lastupdate,
      productImage: value?.productImage,
    })),
  };

  // // get ProductCategory option
  // const fetchProductCategory = () => {
  //   setIsLoading(true);
  //   request(BASEURL, allProductCategories)
  //     .then((res) => {
  //       const Categories = OptionConvert(
  //         res?.allProductCategories?.data,
  //         "categoryName",
  //         "id"
  //       );
  //       setProductCategoryOptions((prevOptions) => [
  //         { label: "All", value: "All" },
  //         ...Categories,
  //       ]);
  //     })
  //     .finally(() => {
  //       setIsLoading(false);
  //     });
  // };

  // // Function to fetch brands
  // const fetchBrand = () => {
  //   setIsLoading(true);
  //   request(BASEURL, allBrands)
  //     .then((res) => {
  //       const brand = OptionConvert(res?.allBrands?.data, "brandName", "id");
  //       setBrandOptions((prevOptions) => [
  //         { label: "All", value: "All" },
  //         ...brand,
  //       ]);
  //     })
  //     .finally(() => {
  //       setIsLoading(false);
  //     });
  // };

  // //get product option
  // const fetchProduct = () => {
  //   setIsLoading(true);
  //   request(BASEURL, allProducts)
  //     .then((res) => {
  //       const product = OptionConvert(
  //         res?.allProducts.data,
  //         "productName",
  //         "id"
  //       );
  //       setProductOptions((prevOptions) => [...prevOptions, ...product]);
  //     })
  //     .finally(() => {
  //       setIsLoading(false);
  //     });
  // };

  //get agent name option
  const fetchAgentName = () => {
    setIsLoading(true);
    request(BASEURL, allUsers)
      .then((res) => {
        const productName = OptionConvert(res?.allUsers, "employeeName", "id");
        setAgentOptions((prevOptions) => [...prevOptions, ...productName]);
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

   const fetchCompetitorAnalysisData = async (fromDate = "", toDate = "") => {
    setIsLoading(true);
    try {
      const res = await request(BASEURL, getAllCompetitorProducts, {
        filters: {
          search: "",
          fromDate: fromDate == "" ? null : fromDate,
          toDate: toDate == "" ? null : toDate,
        },
      });

      const product = OptionConvert(
          res?.getAllCompetitorProducts.data,
          "productName",
          "id"
        );
        setProductOptions((prevOptions) => [...prevOptions, ...product]);

        const brand = OptionConvert(res?.getAllCompetitorProducts?.data, "productBrand", "id");
        setBrandOptions((prevOptions) => [
          { label: "All", value: "All" },
          ...brand,
        ]);

        const Categories = OptionConvert(
          res?.getAllCompetitorProducts?.data,
          "productCategory",
          "id"
        );
        setProductCategoryOptions((prevOptions) => [
          { label: "All", value: "All" },
          ...Categories,
        ]);

    } catch (error) {
      console.error(error)
    } finally {
    }
    setIsLoading(false);
  };

  //filter submit
   const submitFilter = (data) => {
    const agentName =
      SlowMovingItemsData?.agentName?.length > 0
        ? SlowMovingItemsData.agentName.map((item) => item.value)
        : [];
 
    const productCategories =
      SlowMovingItemsData?.productCategory?.length > 0
        ? SlowMovingItemsData.productCategory.map((item) => item.label)
        : [];
 
    const productName =
      SlowMovingItemsData?.productName?.length > 0
        ? SlowMovingItemsData.productName.map((item) => item.value)
        : [];
 
    const brands =
      SlowMovingItemsData?.brand?.length > 0
        ? SlowMovingItemsData.brand.map((item) => item.value)
        : [];

 
    fetchFilteredStock(
      SlowMovingItemsData.fromDate,
      SlowMovingItemsData.toDate,
      agentName,
      productCategories,
      productName,
      brands
    );
  };


const fetchFilteredStock = (
    startDate,
    endDate,
    agents,
    productCategories,
    productName,
    brands
  ) => {
    setIsLoading(true);
 
    const payload = {
      startDate: startDate,
      endDate: endDate,
      agentNames: agents,
      productCategories: productCategories,
      productNames: productName,
      brands: brands,
    };
 
    request(BASEURL, GetCompetitorAnalysisReport, payload)
      .then((res) => {
        const newdata = res?.getCompetitorAnalysisReport?.data;
        setData(newdata);
        resetPagination();
      })
      .catch((err) => {
        const message =
          err?.response?.errors?.[0]?.message ||
          err?.message ||
          "Something went wrong";
        Swal.fire({
          position: "top",
          icon: "error",
          title: message,
          showConfirmButton: true,
        });
      })
      .finally(() => {
        setIsLoading(false);
      });
  };
 
  //download file
  const handleDownload = (
    startDate,
    endDate,
    agentsName,
    productName,
    productCategories,
    brands
  ) => {
    const agentsData =
      agentsName?.length > 0 ? agentsName.map((item) => item.value) : [];
 
    const productData =
      productName?.length > 0 ? productName.map((item) => item.label) : [];
 
    const productCategorieData =
      productCategories?.length > 0
        ? productCategories?.map((item) => item.value)
        : [];
 
 
    const brandData =
      brands?.length > 0 ? brands?.map((item) => item.value) : [];
 
    setCirleLoading(true);
    request(BASEURL, ExportCompetitorReport, {
      startDate: startDate,
      endDate: endDate,
      agentNames: agentsData,
      productCategories: productCategorieData,
      productNames: productData,
      brands: brandData,
    })
      .then(async (res) => {
        const status = res?.exportCompetitorAnalysisReport?.success;
 
        const pdfurl = `${URL}${res?.exportCompetitorAnalysisReport?.fileUrl?.slice(
          1
        )}`;
 
        if (status) {
          const status = await downloadExcelFile(
            pdfurl,
            "competitor_analysis.xlsx"
          );
          setCirleLoading(false);
        }
      })
      .finally(() => {
        setCirleLoading(false);
      });
  };

  return (
    <DashboardLayout>
      <Card>
        <CardHeader
          title={
            <Stack
              direction="row"
              justifyContent="space-between"
              alignItems="center"
              spacing={2}
            >
              <Stack direction="column" spacing={0}>
                <MaterialTypography variant="h5" fontWeight="medium">
                  Competitor Analysis List
                </MaterialTypography>
              </Stack>
              {SlowMovingItemsData?.fromDate && SlowMovingItemsData?.toDate && (
                <button
                  className="container-btn-file"
                  onClick={() => {
                    handleDownload(
                      SlowMovingItemsData?.fromDate,
                      SlowMovingItemsData?.toDate,
                      SlowMovingItemsData?.agentName,
                      SlowMovingItemsData?.productName,
                      SlowMovingItemsData?.productCategory,
                      SlowMovingItemsData?.brand
                      
                    );
                  }}
                  style={{
                    height: "38px",
                    marginLeft: "0",
                    display: "flex",
                    alignItems: "center",
                    cursor: "pointer",
                    fontSize: "14px",
                  }}
                >
                  <svg
                    fill="#fff"
                    xmlns="http://www.w3.org/2000/svg"
                    width="20"
                    height="20"
                    viewBox="0 0 50 50"
                  >
                    <path d="M28.8125 .03125L.8125 5.34375C.339844 5.433594 0 5.863281 0 6.34375L0 43.65625C0 44.136719 .339844 44.566406 .8125 44.65625L28.8125 49.96875C28.875 49.980469 28.9375 50 29 50C29.230469 50 29.445313 49.929688 29.625 49.78125C29.855469 49.589844 30 49.296875 30 49L30 1C30 .703125 29.855469 .410156 29.625 .21875C29.394531 .0273438 29.105469 -.0234375 28.8125 .03125ZM32 6L32 13L34 13L34 15L32 15L32 20L34 20L34 22L32 22L32 27L34 27L34 29L32 29L32 35L34 35L34 37L32 37L32 44L47 44C48.101563 44 49 43.101563 49 42L49 8C49 6.898438 48.101563 6 47 6ZM36 13L44 13L44 15L36 15ZM6.6875 15.6875L11.8125 15.6875L14.5 21.28125C14.710938 21.722656 14.898438 22.265625 15.0625 22.875L15.09375 22.875C15.199219 22.511719 15.402344 21.941406 15.6875 21.21875L18.65625 15.6875L23.34375 15.6875L17.75 24.9375L23.5 34.375L18.53125 34.375L15.28125 28.28125C15.160156 28.054688 15.035156 27.636719 14.90625 27.03125L14.875 27.03125C14.8125 27.316406 14.664063 27.761719 14.4375 28.34375L11.1875 34.375L6.1875 34.375L12.15625 25.03125ZM36 20L44 20L44 22L36 22ZM36 27L44 27L44 29L36 29ZM36 35L44 35L44 37L36 37Z" />
                  </svg>
                  Export File
                </button>
              )}
            </Stack>
          }
        />
        {/* taps */}
        <Box sx={{ my: "5px" }}>
          <Stack
            direction="row"
            justifyContent="space-between"
            alignItems="center"
            spacing={2}
          >
            <Box sx={{ width: "50%", bgcolor: "background.paper" }}>
              <Tabs
                value={value}
                onChange={handleChange}
                TabIndicatorProps={{
                  style: {
                    backgroundColor: "#2a9941",
                    color: "white",
                  },
                }}
                centered
              >
                <Tab label="Table list view" />
                <Tab label="Graph view" />
              </Tabs>
            </Box>
            <Box
              sx={{
                display: "flex",
                justifyContent: "flex-end",
                gap: 2,
                bgcolor: "background.paper",
              }}
            >
              <IconButton
                onClick={() => setDialogOpen(true)}
                aria-label="Filters"
                color="primary"
                sx={{ mt: 2 }}
              >
                <FilterListIcon fontSize="large" />
              </IconButton>
              <IconButton
                onClick={resetFilters}
                aria-label="Reset Filters"
                color="primary"
                sx={{ mt: 2 }}
              >
                <RefreshIcon fontSize="large" />
              </IconButton>
            </Box>
          </Stack>
        </Box>

        <ReusableFilter
          data={SlowMovingItemsData}
          dispatch={dispatch}
          open={dialogOpen}
          onClose={() => setDialogOpen(false)}
          onSave={(data) =>
            submitFilter({
              ...data,
              SlowMovingItemsData,
            })
          }
          title="Competitor Analysis Filter"
        >
          <Grid size={{ xs: 12, sm: 6 }}>
            <MaterialBox lineHeight={0} display="inline-block">
              <MaterialTypography
                component="label"
                variant="caption"
                fontWeight="bold"
              >
                Agent Name 
              </MaterialTypography>
            </MaterialBox>
            <Autocomplete
              multiple
              id="tags-outlined"
              options={agentOptions || []}
              getOptionLabel={(option) => option.label || ""}
              value={SlowMovingItemsData?.agentName || []}
              onChange={(event, newValue) => {
                dispatch({ value: newValue, name: "agentName" });
              }}
              filterSelectedOptions
              renderTags={(selected, getTagProps) =>
                (selected || []).map((option, index) => (
                  <Chip
                    key={index}
                    label={option.label}
                    {...getTagProps({ index })}
                  />
                ))
              }
              renderInput={(params) => (
                <TextField {...params} placeholder="Select Category(s)" />
              )}
            />
          </Grid>

          <Grid size={{ xs: 12, sm: 6 }}>
            <MaterialBox lineHeight={0} display="inline-block">
              <MaterialTypography
                component="label"
                variant="caption"
                fontWeight="bold"
              >
                Brand Name
              </MaterialTypography>
            </MaterialBox>
            <Autocomplete
              multiple
              id="brand-name-autocomplete"
              options={brandOptions || []}
              getOptionLabel={(option) => option.label || ""}
              value={SlowMovingItemsData?.brand || []}
              onChange={(event, newValue) => {
                dispatch({ value: newValue, name: "brand" });
              }}
              filterSelectedOptions
              renderTags={(selected, getTagProps) =>
                (selected || []).map((option, index) => (
                  <Chip
                    key={index}
                    label={option.label}
                    {...getTagProps({ index })}
                  />
                ))
              }
              renderInput={(params) => (
                <TextField
                  {...params}
                  placeholder="Select Brand(s)"
                />
              )}
            />
          </Grid>

          <Grid size={{ xs: 12, sm: 6 }}>
            <MaterialBox lineHeight={0} display="inline-block">
              <MaterialTypography
                component="label"
                variant="caption"
                fontWeight="bold"
              >
                Product Category
              </MaterialTypography>
            </MaterialBox>
            <Autocomplete
              multiple
              id="product-category-autocomplete"
              options={productCategoryOptions || []}
              getOptionLabel={(option) => option.label || ""}
              value={SlowMovingItemsData?.productCategory || []}
              onChange={(event, newValue) => {
                dispatch({ value: newValue, name: "productCategory" });
              }}
              filterSelectedOptions
              renderTags={(selected, getTagProps) =>
                (selected || []).map((option, index) => (
                  <Chip
                    key={index}
                    label={option.label}
                    {...getTagProps({ index })}
                  />
                ))
              }
              renderInput={(params) => (
                <TextField
                  {...params}
                  placeholder="Select Category(s)"
                />
              )}
            />
          </Grid>

          <Grid size={{ xs: 12, sm: 6 }}>
            <MaterialBox lineHeight={0} display="inline-block">
              <MaterialTypography
                component="label"
                variant="caption"
                fontWeight="bold"
              >
                Product Name 
              </MaterialTypography>
            </MaterialBox>
            <Autocomplete
              multiple
              id="tags-outlined"
              options={productOptions || []}
              getOptionLabel={(option) => option.label || ""}
              value={SlowMovingItemsData?.productName || []}
              onChange={(event, newValue) => {
                dispatch({ value: newValue, name: "productName" });
              }}
              filterSelectedOptions
              renderTags={(selected, getTagProps) =>
                (selected || []).map((option, index) => (
                  <Chip
                    key={index}
                    label={option.label}
                    {...getTagProps({ index })}
                  />
                ))
              }
              renderInput={(params) => (
                <TextField {...params} placeholder="Select Product(s)" />
              )}
            />
          </Grid>
        </ReusableFilter>

        {value === 0 ? (
          //Table list view
          <Box>
            {!isLoading && (
              <MaterialDataGrid
                rows={SlowMovingItemsListTable?.rows}
                columns={SlowMovingItemsListTable?.columns}
                isSelectable={false}
                localeText={{
                  noRowsLabel: (
                    <Stack
                      direction="column"
                      alignItems="center"
                      justifyContent="center"
                      spacing={1}
                    >
                     <MaterialTypography
  variant="body2"
  fontWeight="medium"
  color="text"
>
  No results match your filters
</MaterialTypography>

<MaterialTypography variant="caption" color="text">
  Try adjusting or clearing the filters to see Competitor Analysis data.
</MaterialTypography>

                    </Stack>
                  ),
                }}
              />
            )}
          </Box>
        ) : (
          //graph list view with pagination
          <Box>
            <ResponsiveContainer width="100%" height={400}>
              <BarChart
                data={currentData}
                margin={{ top: 20, right: 30, left: 20, bottom: 5 }}
                barSize={30}
              >
                <CartesianGrid strokeDasharray="3 3" />
                <XAxis dataKey="productName" />
                <YAxis />
                <Tooltip
                  contentStyle={{
                    fontSize: "12px",
                    borderRadius: "8px",
                    background: "rgba(255, 255, 255, 0.8)",
                    border: "1px solid #ccc",
                    padding: "2px",
                  }}
                  wrapperStyle={{ outline: "none" }}
                />
                <Legend wrapperStyle={{ fontSize: "12px" }} />
                <Bar dataKey="competitorPrice" fill="#8884d8" name="Competitor Price" />
              </BarChart>
            </ResponsiveContainer>

            {/* Pagination Controls */}
            <Box display="flex" justifyContent="center" mt={2} mb={2}>
              <IconButton
                onClick={handlePrevious}
                disabled={currentPage === 0}
                aria-label="previous page"
              >
                <ArrowBackIosIcon />
              </IconButton>
              <Typography variant="body1" mx={2}>
                Page {currentPage + 1} of {totalPages}
              </Typography>
              <IconButton
                onClick={handleNext}
                disabled={currentPage >= totalPages - 1}
                aria-label="next page"
              >
                <ArrowForwardIosIcon />
              </IconButton>
            </Box>
          </Box>
        )}

        {isLoading && <PageLoading />}
      </Card>
    </DashboardLayout>
  );
}

export default CompetitorAnalysisReport;
